import { useQuery } from '@tanstack/react-query'

import {
  toClientStatement,
  yearParam,
  type ClientStatementWire,
} from '@/features/clients/api/clientWire'
import { api } from '@/lib/api'
import { queryKeys } from '@/lib/query'
import type { ClientStatement, YearFilter } from '@/types/domain'

/** One client's yearly statement: the record with its contacts, the opening
 *  balance, one row per case and the totals. 404 for both a missing and an
 *  out-of-scope client, so existence is never leaked (AD-5). */
export function useClientStatement(id: string | undefined, year: YearFilter) {
  return useQuery<ClientStatement>({
    queryKey: queryKeys.directories.clientStatement(id ?? '', year),
    enabled: Boolean(id),
    queryFn: async () =>
      toClientStatement(
        await api.get<ClientStatementWire>(`/clients/${id}/statement`, {
          params: { year: yearParam(year) },
        }),
      ),
  })
}
